import { useEffect, useRef, useState } from 'react'
import FilterPill from '../FilterPill/FilterPill'
import CustomizedErrorBoundary from '../CustomizedErrorBoundary/CustomizedErrorBoundary'

export default function CustomModuleHeading({
    filteredData,
    pills,
    handlefilteredData,
    onRemovePill,
    setClearBtn,
    filteredLabel,
    title = ' ',
    children,
    isFiltered = false,
    nonRemovablePills, 
}) {
    const [secondDivWidth, setSecondDivWidth] = useState(0)
    const containerRef = useRef(null)
    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                if (entry?.target === containerRef?.current) {
                    setSecondDivWidth(entry?.contentRect?.width)
                }
            }
        })

        if (containerRef?.current) {
            resizeObserver?.observe(containerRef?.current)
        }

        return () => {
            if (containerRef?.current) {
                // eslint-disable-next-line react-hooks/exhaustive-deps
                resizeObserver?.unobserve(containerRef?.current)
            }
        }
    }, [containerRef])

    const reorderItemsOnWrap = () => {
        let isFlag = false
        const container = containerRef?.current
        const items = Array.from(container?.children)

        // Reset order first
        items?.forEach((item) => (item.style.order = ''))

        const firstItemTop = items[0]?.getBoundingClientRect()?.top
        items?.forEach((item, index) => {
            const itemTop = item?.getBoundingClientRect()?.top
            if (itemTop > firstItemTop) {
                isFlag = true
            }
        })
        if (isFlag) {
            const item1 = items[0]
            const item2 = items[1]
            const item3 = items[2]
            item2.style.order = 2
            item1.style.order = 1
            item3.style.order = 1
        }
    }

    useEffect(() => {
        reorderItemsOnWrap()
    }, [filteredData, secondDivWidth])

    return (
        <CustomizedErrorBoundary key={`custom-module-heading-mainTitle`}>
            <div className={`mainTittle`} ref={containerRef}>
                <div
                    className="fltrHeading d-flex align-items-center"
                    style={{ marginRight: 'auto' }}
                >
                    <h1>{title}</h1>
                </div>
                <CustomizedErrorBoundary key={`filter-pills`}>
                    <div
                        className="d-none d-sm-block fltrPills"
                        style={{ marginLeft: 'auto' }}
                    >
                        {Object?.keys(filteredData)?.length > 0 && (
                            <FilterPill
                                filteredData={pills}
                                handlefilteredData={handlefilteredData}
                                setClearBtn={setClearBtn}
                                onRemovePill={onRemovePill}
                                filteredLabel={filteredLabel}
                                isFiltered={isFiltered}
                                 nonRemovablePills={nonRemovablePills}
                            />
                        )}
                    </div>
                </CustomizedErrorBoundary>
                {children || null}
            </div>
        </CustomizedErrorBoundary>
    )
}
